// extracted by mini-css-extract-plugin
module.exports = {"loadingCircle":"PlayPauseButton_loadingCircle__raXfO","loadingMedia":"PlayPauseButton_loadingMedia__eyjri","playPauseImg":"PlayPauseButton_playPauseImg__2BVOR"};